import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFacebook = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M24 12a12 12 0 1 0-13.88 11.85v-8.38H7.08V12h3.04V9.36c0-3.01 1.8-4.67 4.54-4.67 1.31 0 2.68.23 2.68.23v2.96h-1.5c-1.5 0-1.96.92-1.96 1.87V12h3.32l-.53 3.47h-2.8v8.38A12 12 0 0 0 24 12Z" }), /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M16.67 15.47 17.2 12h-3.32V9.75c0-.95.46-1.88 1.95-1.88h1.51V4.92s-1.37-.23-2.68-.23c-2.74 0-4.54 1.66-4.54 4.67V12H7.08v3.47h3.04v8.38c1.25.2 2.51.2 3.76 0v-8.38h2.8Z"
	})]
});
export default SvgFacebook;
